import { ApplyResult, PrepareResult, ProcessResult, StageStatus } from './types'

import { INode } from 'shared/types/tree'
import { atom } from 'infrastructure/state/jotai.wrapper'

// Core pipeline atoms
export const workingTreeAtom = atom<INode | undefined>()

// Stage status atoms
export const prepareStatusAtom = atom<StageStatus | null>(null)
export const processStatusAtom = atom<StageStatus | null>(null)
export const applyStatusAtom = atom<StageStatus | null>(null)

// Pipeline status atoms
export const pipelineStatusAtom = atom<string>('')
export const pipelineErrorAtom = atom<string | null>(null)

// Stage result atoms
export const prepareResultAtom = atom<PrepareResult | null>(null)
export const processResultAtom = atom<ProcessResult | null>(null)
export const applyResultAtom = atom<ApplyResult | null>(null)

// Process stage configuration atoms
export const selectedProviderAtom = atom<string>('openai')
export const selectedModelAtom = atom<string>('gpt-5')
